import React from "react";
import { Controller } from "react-hook-form";
import { Col, Input, Label, Row } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";

interface ControlledTextFieldProps {
  label?: string;
  inputName: string;
  inputType: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  value?: string | FileList;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
}

type MyInputType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "datetime-local"
  | "time"
  | "week"
  | "month"
  | "color"
  | "file";

const TimeSelector: React.FC<ControlledTextFieldProps> = ({
  label,
  inputName,
  inputType,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
  className,
  onChange,
}) => {
  return (
    <div className="my-1">
      <Row>
        <Col lg="4">
          <Label className="pt-1 form-label" htmlFor={inputName}>
            {isRequired ? `${label} ` : label}
          </Label>
        </Col>
        <Col lg="8">
          <Controller
            name={inputName}
            control={control}
            rules={rules}
            defaultValue={defaultValue}
            render={({ field }) => (
              <Input
                id={inputName}
                type={inputType as MyInputType}
                placeholder={placeholder}
                invalid={invalid}
                disabled={isDisabled}
                {...field}
                className={className}
                required={isRequired}
                step={inputType === "number" ? "any" : undefined}
                onChange={(e) => {
                  field.onChange(e);
                  if (onChange) {
                    onChange(e);
                  }
                }}
              />
            )}
          />
          {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
          {invalid && (
            <ValidationMsgComponent
              inputName={inputName}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TimeSelector;
